export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER_DETAIL = 'FETCH_USER_DETAIL'

export const ADD_GENRE = 'ADD_GENRE'
export const FETCH_RECOMMENDATION = 'FETCH_RECOMMENDATION'
export const CREATE_PLAYLIST = 'CREATE_PLAYLIST'
export const RESET_PLAYLIST = 'RESET_PLAYLIST'
export const FIll_PLAYLIST = 'FIll_PLAYLIST'
